import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { WEBSITE_SETTINGS_DEFAULTS } from '../helper/websiteMeta';

const DEFAULTS = WEBSITE_SETTINGS_DEFAULTS;

export function useWebsiteSettings(token) {
    const [settings, setSettings] = useState({
        ...DEFAULTS,
        logo: { url: null, filename: null },
        favicon: { url: null, filename: null },
    });
    const [loading, setLoading] = useState(true);

    const loadSettings = useCallback(async () => {
        setLoading(true);
        try {
            const res = await axios.get('api/website-settings', {
                headers: token ? { Authorization: `Bearer ${token}` } : {},
                withCredentials: true,
            });
            setSettings({
                institutionName: res.data?.institutionName || DEFAULTS.institutionName,
                systemTitle: res.data?.systemTitle || DEFAULTS.systemTitle,
                footerText: res.data?.footerText || DEFAULTS.footerText,
                logo: res.data?.logo || { url: null, filename: null },
                favicon: res.data?.favicon || { url: null, filename: null },
            });
        } catch {
            setSettings({
                ...DEFAULTS,
                logo: { url: null, filename: null },
                favicon: { url: null, filename: null },
            });
        } finally {
            setLoading(false);
        }
    }, [token]);

    useEffect(() => {
        loadSettings();
    }, [loadSettings]);

    useEffect(() => {
        const reload = () => loadSettings();
        window.addEventListener('website-logo:updated', reload);
        window.addEventListener('website-favicon:updated', reload);
        window.addEventListener('website-settings:updated', reload);
        return () => {
            window.removeEventListener('website-logo:updated', reload);
            window.removeEventListener('website-favicon:updated', reload);
            window.removeEventListener('website-settings:updated', reload);
        };
    }, [loadSettings]);

    return { settings, loading, reloadSettings: loadSettings };
}
